import {Component, OnInit} from '@angular/core';
import { ActivatedRoute, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs';
import {LoadingService} from "../../../services/loading.service";
import {CandidatStatusOnMission} from "../../../shared/utils/enums";
// import { BreadcrumbService } from 'xng-breadcrumb';

@Component({
  selector: 'app-missions',
  templateUrl: './missions.component.html',
  styleUrl: './missions.component.scss'
})
export class MissionsComponent implements OnInit {
  urlCheck : boolean
  validaionMissions : boolean
  filterList = [
    {label : 'Terminés',value : CandidatStatusOnMission.ARCHIVED},
    {label : 'Confirmés',value : CandidatStatusOnMission.ACCEPTED_AND_SIGNED_BY_BOTH},
    {label : 'Acceptés',value : CandidatStatusOnMission.ACCEPTED},
    {label : 'Publiés',value : CandidatStatusOnMission.NEUTRAL},
    {label : 'Non publiés',value : CandidatStatusOnMission.WAITING_FOR_ESTABLISHMENT_VALIDATION},
]
listUrls : any = {
  path: 'missions',
  label : 'Missions',
  url: '/dashboard/missions',
  children: [
  ]
}
  constructor(
    // private breadcrumbService: BreadcrumbService,
    private activeRoute : ActivatedRoute,
    private loadingService : LoadingService,
    private router : Router
  ) {
   }

  ngOnInit(): void {
    // this.breadcrumbService.set('@Missions', 'Missions');
    // this.breadcrumbService.set('@add', 'Créer une mission');
    this.urlCheck = this.router.url.includes('add')
    this.validaionMissions = this.router.url.includes('validation')
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        // Navigation is starting... show a loading spinner perhaps?
        // blog on that here: ultimatecourses.com/blog/angular-loading-spinners-with-router-events
        this.urlCheck = this.router.url.includes('add')
        this.validaionMissions = this.router.url.includes('validation')
      }
      if (event instanceof NavigationEnd) {
        // We've finished navigating
        this.urlCheck = this.router.url.includes('add')
        this.validaionMissions = this.router.url.includes('validation')
      }
      if (event instanceof NavigationError) {
        // something went wrong, log the error
          this.urlCheck = false
          this.validaionMissions = false
      }
    });
  }

  submitLoading() {
    this.loadingService.toggleLoading(!this.loadingService.loading);
  }
}
